import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        module: '.rfct-card-slider',
        slideContainer: '.rfct-card-slider__slide-container',
        slide: '.rfct-card-slider__slide',
    },
    dataAttributes: {
        slidesXS: 'slides-xs',
        slidesMD: 'slides-md',
        slidesLG: 'slides-lg',
    },
    sliderConfig: {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        centerMode: false,
        // lazyLoad: 'ondemand',
        infinite: false,
        prevArrow: '<button class="rfct-button__prev rfct-button rfct-button--secondary rfct-button--mini"><span class="rfct-button__inner"><span class="rfct-button__icon material-icons">chevron_left</span></span></button>',
        nextArrow: '<button class="rfct-button__next rfct-button rfct-button--secondary rfct-button--mini"><span class="rfct-button__inner"><span class="rfct-button__icon material-icons">chevron_right</span></span></button>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    centerMode: false,
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                    dots: false,
                    arrows: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.25,
                    slidesToScroll: 1,
                    centerMode: false,
                    dots: false,
                    arrows: true,
                },
            },
        ],
    },
};

export default class CardSlider {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = this._getDomElements();
        //  this._bindEvents();
        this._isMac = false;
    }

    _getDomElements() {
        return {
            $slideContainer: this._$rootElement.find(config.selectors.slideContainer),
        };
    }
    _detectIsMac() {
        //Proof if we are on Apple product
        if (navigator.userAgentData) {
            return navigator.userAgentData.platform === "macOS";
        } else {
            return /Macintosh|MacIntel|MacPPC|Mac68K|iPhone|iPad|iPod/.test(navigator.userAgent);
        }
    }

    _mergeConfig() {
        const xs = this._$rootElement.data(config.dataAttributes.slidesXS);
        const md = this._$rootElement.data(config.dataAttributes.slidesMD);
        const lg = this._$rootElement.data(config.dataAttributes.slidesLG);

        const sliderConfig = Object.assign(config.sliderConfig);

        if (lg) {
            sliderConfig.responsive[0].slidesToShow = lg;
            sliderConfig.slidesToShow = lg;
        }

        if (md) {
            sliderConfig.responsive[1].slidesToShow = md;
        }

        if (xs) {
            sliderConfig.responsive[2].settings.slidesToShow = xs;
        }

        return sliderConfig;
    }


    _bindEvents() {

        document.addEventListener('slider:loaded', (e) => {
            const container = e.detail.container;
            this.init(container);
        });

    }

    init() {
        // if (!container) return;
        this._isMac = this._detectIsMac();
        const sliderContainers = this._$rootElement.find('.rfct-card-slider__slide-container');
console.log("sliderContainers.hasClass('swiper')", sliderContainers.hasClass('swiper'), sliderContainers)
        if(!sliderContainers.hasClass('swiper')) {
            this._elements.$slideContainer.slick(this._mergeConfig());
        }

        if (sliderContainers[0].dataset.swiperInitialized === 'true') return;

        this._addNavigationButtons(sliderContainers[0]);

        const swiper = new Swiper(sliderContainers[0], this._getSliderConfig(sliderContainers[0]));

        sliderContainers[0].dataset.swiperInitialized = 'true';

        sliderContainers[0]._swiperInstance = swiper;

    }

    _addNavigationButtons(sliderEl) {

        if (sliderEl.querySelector('.rfct-button__prev')) return;

        const buttonPrev = document.createElement('button');
        buttonPrev.className = 'rfct-button__prev rfct-button rfct-button--secondary rfct-button--mini';

        const buttonNext = document.createElement('button');
        buttonNext.className = 'rfct-button__next rfct-button rfct-button--secondary rfct-button--mini';

        buttonPrev.innerHTML =
            '<span class="rfct-button__inner"><span class="rfct-button__icon material-icons">chevron_left</span></span>';

        buttonNext.innerHTML =
            '<span class="rfct-button__inner"><span class="rfct-button__icon material-icons">chevron_right</span></span>';

        sliderEl.closest('.rfct-card-slider__slider').appendChild(buttonPrev);
        sliderEl.closest('.rfct-card-slider__slider').appendChild(buttonNext);

    }

    _getSliderConfig($slider) {
        const _this = this;
        const xs = this._$rootElement.data(config.dataAttributes.slidesXS);
        const md = this._$rootElement.data(config.dataAttributes.slidesMD);
        const lg = this._$rootElement.data(config.dataAttributes.slidesLG);
        console.log()
        return {
            slidesPerView: xs || 1.25,
            slidesPerGroup: 1,
            speed: 750,
            loop: false,
            allowTouchMove: true,
            simulateTouch: true,
            grabCursor: true,
            autoplay: false,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            resistance: true,
            resistanceRatio: 0.85,
            ally: true,
            followFinger: true,

            freeMode: {
                enabled: true,
                sticky: true,
            },

            mousewheel: {
                forceToAxis: true,
                sensitivity: 1,
                invert: this._isMac,
                releaseOnEdges: true
            },
            centeredSlides: false,
            observer: true,
            observeParents: true,
            spaceBetween: 40,
            navigation: {
                nextEl: $slider.parentNode.querySelector('.rfct-button__next'),
                prevEl: $slider.parentNode.querySelector('.rfct-button__prev')
            },
            breakpoints: {
                992: { slidesPerView: lg || 3 },
                768: { slidesPerView: md || 2 },
            }
        };
    }
}

moduleRegistry.registerModule('CardSlider', CardSlider);
moduleRegistry.autoApplyModule('CardSlider', config.selectors.module);
